import moment from 'moment';

export interface ICalendarEvent {
	title: string;
	date: Date;
	tintColor: string;
	isRSVP: boolean;
}

export const calendarEventDayKey = (date: Date) => {
	return moment(date).format('YYYY-MM-DD');
};
